import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AdminLanguageProvider } from './AdminLanguageContext';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Tasks from './pages/Tasks';
import Posts from './pages/Posts';
import Announcements from './pages/Announcements';
import Categories from './pages/Categories';
// 新增页面
import Bids from './pages/Bids';
import Reviews from './pages/Reviews';
import Reports from './pages/Reports';
import Points from './pages/Points';
import Submissions from './pages/Submissions';
import MarketplaceReview from './pages/MarketplaceReview';
import AdminSettings from './pages/AdminSettings';
// 财务（支付系统）
import FinanceDashboard from './pages/FinanceDashboard';
import Wallets from './pages/Wallets';
import Orders from './pages/Orders';
import Disputes from './pages/Disputes';
import Withdrawals from './pages/Withdrawals';
import CheckoutRequests from './pages/CheckoutRequests';
import NotFound from './pages/NotFound';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('admin_token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AdminLanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={
            <PrivateRoute>
              <Layout>
                <Routes>
                  <Route path="/"              element={<Dashboard />} />
                  <Route path="/users"         element={<Users />} />
                  <Route path="/tasks"         element={<Tasks />} />
                  <Route path="/bids"          element={<Bids />} />
                  <Route path="/submissions"   element={<Submissions />} />
                  <Route path="/marketplace"   element={<MarketplaceReview />} />
                  <Route path="/reviews"       element={<Reviews />} />
                  <Route path="/reports"       element={<Reports />} />
                  <Route path="/posts"         element={<Posts />} />
                  <Route path="/categories"    element={<Categories />} />
                  <Route path="/announcements" element={<Announcements />} />
                  <Route path="/points"        element={<Points />} />
                  <Route path="/finance"       element={<FinanceDashboard />} />
                  <Route path="/wallets"       element={<Wallets />} />
                  <Route path="/orders"        element={<Orders />} />
                  <Route path="/disputes"      element={<Disputes />} />
                  <Route path="/checkout-requests" element={<CheckoutRequests />} />
                  <Route path="/withdrawals"   element={<Withdrawals />} />
                  <Route path="/settings"      element={<AdminSettings />} />
                  <Route path="*"              element={<NotFound />} />
                </Routes>
              </Layout>
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AdminLanguageProvider>
  );
}
